import * as yup from 'yup';

const variantLibraryOptionsSchema = yup.object({
  name: yup
    .string()
    .trim()
    .max(250, 'Must be less than 250 characters')
    .required('Name is a required field'),
});

export const variantLibrarySchema = (isProjectSelection: boolean) =>
  yup.object({
    name: yup
      .string()
      .max(250, 'Must be less than 250 characters')
      .required('Name is a required field'),
    id: yup.string().when([], {
      is: () => isProjectSelection,
      then: (schema) => schema.required('Variant type is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
    options: yup.array().of(variantLibraryOptionsSchema).min(1, 'At least one option is required'),
  });
